export class ReferenceTurbine {
    id : number;
    manufacturer: string;
    name: string;
    model: string;
    rating: string;
    description: string;

    public deserialize(input: any): this {
        this.id = input.id;
        this.manufacturer = input.manufacturer;
        this.name = input.name;
        this.model = input.model;
        this.rating = input.rating != null && input.rating !== '' ? String(input.rating) : null;
        this.description = input.description;
        return this
    }

}
